import React, { useState } from 'react'

export default function Border({ element, borderRadius, onBorderRadiusChange }) {
  const [open, setOpen] = useState(false)
  return (
    <div tabIndex={0} onBlur={(e) => {
      if (e.currentTarget.contains(e.relatedTarget)) {
        return
      }
      setOpen(false)
    }}>
      <div className='Border' onClick={() => setOpen(true)}>{element}
        <div className={open ? 'Border_Con Border_Con_Open' : 'Border_Con'}>
          <input value={borderRadius || 0} min={0} type='number' onKeyDown={(e)=>e?.stopPropagation()} onChange={(e)=>onBorderRadiusChange(parseFloat(e?.target?.value))}/>
          <input value={borderRadius || 0} min={0} type='range' onKeyDown={(e)=>e?.stopPropagation()} onChange={(e)=>onBorderRadiusChange(parseFloat(e?.target?.value))}/>
        </div>
      </div>
    </div>
  )
}
